import { defineComponent as _defineComponent } from 'vue'
import {
    nextTick,
    reactive,
    ref,
    watch,
  } from "vue";
  import Cleave from "vue-cleave-component";
  import Slider from "@vueform/slider";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SliderLimited',
  props: {
    modelValue: {
      type: Array,
      default: () => [0, 0],
      required: true,
    },
    minTitle: String,
    minValue: {
      type: Number,
      required: true,
    },
    maxTitle: String,
    maxValue: {
      type: Number,
      required: true,
    },
    position: String,
    units: String,
    step: {
      type: Number,
      default: 1,
    },
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  function changeSliderValue(value) {
    emit("update:modelValue", [value[0], value[1]]);
  }
  function changeStart(e: unknown) {
    emit("update:modelValue", [
      e.target.value.replaceAll(",", ""),
      props.modelValue[1],
    ]);
    nextTick(() => {
      checkMin();
    });
  }
  function checkMin() {
    if (props.modelValue[0] < props.minValue) {
      emit("update:modelValue", [props.minValue, props.modelValue[1]]);
    }

    if (props.modelValue[0] > props.maxValue) {
      emit("update:modelValue", [props.maxValue, props.modelValue[1]]);
    }
  }

  function changeEnd(e: unknown) {
    emit("update:modelValue", [
      props.modelValue[0],
      e.target.value.replaceAll(",", ""),
    ]);
    nextTick(() => {
      checkMax();
    });
  }
  function checkMax() {
    if (props.modelValue[1] > props.maxValue) {
      emit("update:modelValue", [props.modelValue[0], props.maxValue]);
    }

    if (props.modelValue[1] < props.minValue) {
      emit("update:modelValue", [props.modelValue[0], props.minValue]);
    }
  }
  watch(
    () => {
      return props.modelValue;
    },
    () => {
      checkMin();
      checkMax();
    },
    { immediate: true }
  );

  const optionNumeric = {
    numeral: true,
    numeralThousandsGroupStyle: "thousand",
    numeralPositiveOnly: true,
  };

  const emit = __emit;

const __returned__ = { props, changeSliderValue, changeStart, checkMin, changeEnd, checkMax, optionNumeric, emit, nextTick, reactive, ref, watch, get Cleave() { return Cleave }, get Slider() { return Slider } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})